/* eslint-disable no-param-reassign */
/* eslint-disable react/prop-types */
import React from 'react'
import * as d3 from 'd3'
import { scaleLinear } from 'd3-scale'
import { geoPath } from 'd3-geo'
import { contourDensity } from 'd3-contour'
import {
    useChartOptions,
    usePixelPositions,
} from '../../Context/ChartContext.tsx'

export default function Contour() {
    const { chartOptions, settings } = useChartOptions()

    const pixelPositions = usePixelPositions()

    const density = contourDensity<{ x: number; y: number }>()
        .x((d) => d.x)
        .y((d) => d.y)
        .thresholds(9)
        .size([settings.vizWidth, settings.vizHeight])
        .bandwidth(8)

    const contours = density(pixelPositions)

    const densityExtent = d3.max(contours, (d) => d.value)

    if (!density.length || !densityExtent) {
        return null
    }

    const colorDensity = scaleLinear<string>()
        .range(['#3661AD', '#ffffff', '#D82129'])
        .domain([0, densityExtent / 2, densityExtent])

    const path = geoPath()

    return (
        <g key="contourChart" id="contourChart">
            {contours.map((d, i) => {
                const stroke = 'none'

                const dAttr = path(d)

                if (!dAttr) {
                    return null
                }

                return (
                    <path
                        // eslint-disable-next-line react/no-array-index-key
                        key={`contour_${i}`}
                        stroke={stroke}
                        d={dAttr}
                        fill={colorDensity(d.value)}
                        opacity={chartOptions.opacity}
                    />
                )
            })}
        </g>
    )
}
